import api from "@/services/api";

class ResetPassword {
  execute = async (
    document: string,
    otp: string,
    password: string,
    email?: string,
  ) => {
    const validate = await api().put(`/reset-password`, {
      otp: otp,
      document: document ? String(document) : undefined,
      email: email?.trim() || undefined,
      password: password,
    });
    return validate;
  };
}

export { ResetPassword };